import { useState, useEffect } from 'react';
import '../dashboard/css/core.css';
import '../dashboard/css/theme-default.css';
import '../dashboard/css/demo.css';
import '../dashboard/libs/perfect-scrollbar/perfect-scrollbar.css';
import '../dashboard/libs/apex-charts/apex-charts.css';
import '../dashboard/js/helpers';
import '../dashboard/js/config';
import '../dashboard/fonts/boxicons.css';
import '../dashboard/css/icons.css';
import '../dashboard/menuisidebar.css';
import avatar from '../dashboard/img/avatars/1.png';
import sem_image from '../dashboard/img/avatars/sem_image.png';

import icone from '../dashboard/img/icons/brands/contrato_de_propriedade.png';
import LocalStorage from '../../helpers/localstorage';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setupAPIclient } from '../../services/setupAPIclient';
import PhoneInput from 'react-phone-input-2';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { BsBoxArrowRight, BsUpload, BsPerson, BsBell, BsBarChart, BsClockHistory } from "react-icons/bs";
import { BiMenu, BiX } from "react-icons/bi";
import { FiAward } from 'react-icons/fi';
import Swal from "sweetalert2";
import AIAssistant from '../AIAssistant';
import { motion } from 'framer-motion';
import ThemeToggle from '../common/ThemeToggle';




interface LayoutProps {
  children: React.ReactNode;
}

type TutorialStep = {
  step: number;
  title: string;
  description: string;
  route: string;
  cta: string;
};

const GUIDED_TUTORIAL_STORAGE_KEYS = [
  "management_guided_user_v1",
  "management_tutorial_region_v1",
  "management_tutorial_unit_v1",
  "management_tutorial_company_v1",
  "management_tutorial_upload_v3",
  "management_tutorial_notification_v3",
  "management_tutorial_agenda_v1",
];
const TUTORIAL_REPLAY_KEY = "management_tutorial_replay";
const TUTORIAL_COMPLETED_KEY = "management_tutorial_completed";
const TUTORIAL_SESSION_PROMPT_KEY = "management_tutorial_session_prompt_step";
const TUTORIAL_SESSION_STEP_OVERRIDE_KEY = "management_tutorial_session_step_override";
const MOBILE_BREAKPOINT = 992;
const getGuidedStorageKeyByStep = (step: number) =>
  GUIDED_TUTORIAL_STORAGE_KEYS[step - 1] || null;

type Country = {
  name: string;
  code: string;
  flag: string;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {

  const localStorage = new LocalStorage();
  const navigate = useNavigate();
  const location = useLocation();

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= MOBILE_BREAKPOINT : false
  );
  const [showModalUpdateSubmaster, setShowModalUpdateSubmaster] = useState(false);
  const [isPermissionGranted, setPermissionGranted] = useState(false);

  const [isCadastroOpen, setCadastroOpen] = useState(false);
  const [isContractOpen, setContractOpen] = useState(false);

  const [countries, setCountries] = useState<Country[]>([]);
  const [selectedCountry, setSelectedCountry] = useState('');

  const [preview, setPreview] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [nextTutorialStep, setNextTutorialStep] = useState<TutorialStep | null>(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number_phone: "",
    city: "",
    //country: "",
    imagecompany_logo: "",
     cod_pix: '',
    cartao_credit: {
      numerocredito: '',
      cvv: '',
      nome: '',
      validade: '',
    },
    due_date: '',
    features: []
  });
  const isAgendaRoute = location.pathname === "/AgendaPage";
  const tutorialSteps: TutorialStep[] = [
    {
      step: 1,
      title: "Cadastrar signatário",
      description: "Cadastre o signatário que vai participar da assinatura e do acompanhamento dos contratos.",
      route: "/UserPage",
      cta: "Ir para signatários",
    },
    {
      step: 2,
      title: "Cadastrar região",
      description: "Etapa opcional. Na tela de regiões, basta informar o nome da região para organizar a estrutura.",
      route: "/RegionForm",
      cta: "Ir para regiões",
    },
    {
      step: 3,
      title: "Cadastrar unidade",
      description: "Cadastre a unidade informando o nome da unidade e vinculando a região cadastrada anteriormente.",
      route: "/UnitForm",
      cta: "Ir para unidades",
    },
    {
      step: 4,
      title: "Cadastrar empresa",
      description: "Defina o nome da empresa, selecione a região e, se quiser, associe uma unidade.",
      route: "/CompanyPage",
      cta: "Ir para empresas",
    },
    {
      step: 5,
      title: "Fazer upload do contrato",
      description: "Envie o contrato, associe os signatários e preencha os dados principais para iniciar o controle.",
      route: "/UploadPage",
      cta: "Ir para upload",
    },
    {
      step: 6,
      title: "Ativar alertas",
      description: "Configure notificações para receber avisos de vencimento e eventos importantes dos contratos.",
      route: "/NotificationPage",
      cta: "Ir para notificações",
    },
    {
      step: 7,
      title: "Ver agenda dos contratos",
      description: "A agenda mostra os contratos próximos do vencimento em uma visão organizada para facilitar o acompanhamento diário.",
      route: "/AgendaPage",
      cta: "Abrir agenda",
    },
  ];

  // Toggle lateral menu
  const toggleMenu = () => setIsCollapsed(!isCollapsed);
  const closeMobileMenu = () => {
    if (isMobile) {
      setIsCollapsed(true);
    }
  };

  // Logout
  const logout = () => {
    localStorage.removeAuthToken();
    window.sessionStorage.removeItem(TUTORIAL_SESSION_PROMPT_KEY);
    window.sessionStorage.removeItem(TUTORIAL_SESSION_STEP_OVERRIDE_KEY);
    navigate("/");
  };

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  // Handle file selection
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if(file){
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result as string);
      reader.readAsDataURL(file);
    } else {
      setSelectedFile(null);
      setPreview(null);
    }
  };

  // Fetch countries
  const handleGetCountries = async () => {
    try {
      const res = await fetch("https://restcountries.com/v3.1/all?fields=name,flags,cca2");
      const data = await res.json();
      const list = data.map((c: any) => ({
        name: c.name.common,
        code: c.cca2,
        flag: c.flags.png
      })).sort((a: Country, b: Country) => a.name.localeCompare(b.name));
      setCountries(list);
    } catch (err) {
      console.error("Erro ao buscar países", err);
    }
  };

  // Handle country select
  const handleChangeCountry = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCountry(e.target.value);
    setFormData({...formData, country: e.target.value});
  };

  // Fetch user data
  const handleGetDataUser = async () => {
    try{
      const token = String(localStorage.getAuthToken());
      const ApiClient = setupAPIclient(token);
      const response = await ApiClient.post("/auth/get/login");
      setFormData(prev => ({...prev, ...response.data}));
      setSelectedCountry(response.data.country || "");
    } catch(error){ console.error(error); }
  };

  // Submit update
  const handleSubmitUpdate = async (e: React.FormEvent) => {
    e.preventDefault();

    // country
    
    const requiredFields = ["name", "email", "city"];
    for(const field of requiredFields){
      if(!String((formData as any)[field]).trim()){
        toast.error(`O campo ${field} é obrigatório!`, { autoClose: 2000 });
        return;
      }
    }

    const token = String(localStorage.getAuthToken());
    const ApiClient = setupAPIclient(token);
    const toastId = toast.loading("Atualizando dados...");

    try{
      
      const fd = new FormData();
      // Object.keys(formData).forEach(key => fd.append(key, (formData as any)[key]));


      // Adiciona apenas campos exceto email
      Object.keys(formData)
      .filter(key => key !== "due_date") // <-- remove email
      .filter(key => key !== "activate_plan") // <-- remove email
      .filter(key => key !== "payment_date") // <-- remove email
      .filter(key => key !== "plan_key") // <-- remove email
      .filter(key => key !== "features") // <-- remove email
      .forEach(key => fd.append(key, (formData as any)[key]));

      const fileInput = document.getElementById("imagecompany_logo") as HTMLInputElement;
      if(fileInput?.files?.[0]) fd.append("imagecompany_logo", fileInput.files[0]);

      const response = await ApiClient.post("/auth/register/update", fd, { headers: { "Content-Type": "multipart/form-data" } });

      if(response.data.error){
        toast.update(toastId, { render: "Por favor digite outro e-mail", type:"warning", isLoading:false, autoClose:1000 });
      } else {
        toast.update(toastId, { render: "Dados atualizados com sucesso!", type:"success", isLoading:false, autoClose:1000, onClose: () => window.location.reload() });
      }

    } catch(error){
      toast.update(toastId, { render: "Erro ao atualizar os dados", type:"error", isLoading:false, autoClose:2000 });
    }
  };


  const getArrayLength = (value: any) => (Array.isArray(value) ? value.length : 0);
  const hasStepData = (allData: any[], name: string) => {
    const item = allData.find((entry: any) => entry?.name === name);
    if (!item) return false;
    const successItems = Array.isArray(item?.data?.success)
      ? item.data.success
      : Array.isArray(item?.success)
      ? item.success
      : [];

    if (successItems.length > 0) return true;
    if (typeof item?.hasData === "boolean") return item.hasData;
    return false;
  };

  const getNextTutorialStep = async () => {
    const colors = {
      lightGray: "#F5F6FA",
      darkGray: "#7A7A7A",
      red: "rgb(93, 173, 226)",
    };
    const replayActive = window.localStorage.getItem(TUTORIAL_REPLAY_KEY) === "1";
    const tutorialCompleted = window.localStorage.getItem(TUTORIAL_COMPLETED_KEY) === "1";

    if (replayActive) {
      const replayStep = localStorage.getStep() ? Number(localStorage.getStep()) : 1;
      return { colors, realStep: replayStep };
    }

    try {
      const token = String(localStorage.getAuthToken());
      const ApiClient = setupAPIclient(token);
      const allDataResponse = await ApiClient.post("/management/get/allData");

      const allData = Array.isArray(allDataResponse?.data)
        ? allDataResponse.data
        : Array.isArray(allDataResponse?.data?.data)
        ? allDataResponse.data.data
        : [];
      const hasAgendaSeen = window.localStorage.getItem("management_tutorial_agenda_seen") === "1";
      const rawStatusByStep = [
        hasStepData(allData, "management_user"),
        hasStepData(allData, "management_region"),
        hasStepData(allData, "management_unit"),
        hasStepData(allData, "management_company"),
        hasStepData(allData, "management_uploaddoc"),
        hasStepData(allData, "management_notification"),
        hasAgendaSeen,
      ];
      const uploadCompleted = rawStatusByStep[4];
      const statusByStep = [
        rawStatusByStep[0],
        rawStatusByStep[1] || uploadCompleted,
        rawStatusByStep[2] || uploadCompleted,
        rawStatusByStep[3] || uploadCompleted,
        rawStatusByStep[4],
        rawStatusByStep[5],
        rawStatusByStep[6],
      ];

      const isFreshAccount = rawStatusByStep.every((done) => !done);

      if (isFreshAccount) {
        GUIDED_TUTORIAL_STORAGE_KEYS.forEach((key) => window.localStorage.removeItem(key));
        window.localStorage.removeItem("management_tutorial_agenda_seen");
        window.localStorage.removeItem(TUTORIAL_COMPLETED_KEY);
        window.localStorage.removeItem(TUTORIAL_REPLAY_KEY);
        window.localStorage.removeItem("management_tutorial_step");
      }

      const nextPendingIndex = statusByStep.findIndex((done) => !done);
      const endpointStep = nextPendingIndex === -1 ? 0 : nextPendingIndex + 1;
      const sessionStepOverride = Number(window.sessionStorage.getItem(TUTORIAL_SESSION_STEP_OVERRIDE_KEY) || "0");
      const realStep = endpointStep === 0
        ? 0
        : Math.max(endpointStep, sessionStepOverride);

      if (tutorialCompleted && realStep > 0) {
        return { colors, realStep: 0, statusByStep: rawStatusByStep, sessionStepOverride };
      }

      if (realStep === 0) {
        window.localStorage.setItem(TUTORIAL_COMPLETED_KEY, "1");
        window.localStorage.removeItem("management_tutorial_step");
      }

      return { colors, realStep, statusByStep: rawStatusByStep, sessionStepOverride };

    } catch (error) {
      console.error("verifyUser ERROR:", error);
      return null;
    }
  };

  const openTutorial = async (force = false) => {
    const tutorialInfo = await getNextTutorialStep();
    if (!tutorialInfo) return;

    const { colors, realStep, statusByStep = [], sessionStepOverride = 0 } = tutorialInfo;
    const replayActive = window.localStorage.getItem(TUTORIAL_REPLAY_KEY) === "1";
    const pendingStep = tutorialSteps.find((item) => item.step === realStep) || null;
    setNextTutorialStep(pendingStep);

    // A agenda nao deve abrir automaticamente a cada login.
    // O passo 7 fica disponivel apenas no replay manual do tutorial.
    if (!force && !replayActive && realStep === tutorialSteps.length) {
      window.localStorage.setItem("management_tutorial_agenda_seen", "1");
      window.localStorage.setItem(TUTORIAL_COMPLETED_KEY, "1");
      window.localStorage.removeItem("management_tutorial_step");
      window.sessionStorage.setItem(TUTORIAL_SESSION_PROMPT_KEY, String(realStep));
      return;
    }

    if (!force && !realStep) return;
    if (!force && window.sessionStorage.getItem(TUTORIAL_SESSION_PROMPT_KEY) === String(realStep)) return;
    if (!force) {
      window.sessionStorage.setItem(TUTORIAL_SESSION_PROMPT_KEY, String(realStep));
    }

    if (realStep) {
      localStorage.savelocalStorage(String(realStep));
    }

    const currentStep = tutorialSteps.find((item) => item.step === (realStep || tutorialSteps.length));
    const checklist = tutorialSteps
        .map((i) => {
          const stepDone = Boolean(statusByStep[i.step - 1]);
          const skippedInSession =
            !stepDone &&
            sessionStepOverride > 0 &&
            i.step < sessionStepOverride;
          const status = realStep === 0
            ? "Concluído"
            : stepDone
            ? "Concluído"
            : skippedInSession
            ? "Em espera"
            : i.step === realStep
            ? "Agora"
            : "Próximo";
          const statusColor =
            status === "Agora"
              ? "#ff7d70"
              : status === "Em espera"
              ? "#d97706"
              : "#64748b";
          return `
            <div style="display:flex;justify-content:space-between;gap:8px;padding:9px 10px;border:1px solid rgba(148,163,184,.25);border-radius:10px;background:#fff;margin-top:8px;">
              <div style="text-align:left;">
                <strong style="font-size:13px;color:#0f172a;">${i.step}. ${i.title}</strong>
              </div>
              <span style="font-size:11px;font-weight:700;color:${statusColor};">${status}</span>
            </div>
          `;
        })
        .join("");

    const result = await Swal.fire({
        title: realStep ? `Tutorial inicial • Passo ${realStep} de ${tutorialSteps.length}` : "Tutorial concluído",
        html: `
          <div style="text-align:left;font-size:14px;color:#475569;line-height:1.6;">
            <p style="margin:0 0 10px 0;"><strong style="color:#0f172a;">${currentStep?.title || "Fluxo finalizado"}</strong></p>
            <p style="margin:0 0 12px 0;">${realStep ? currentStep?.description : "Todos os passos principais do onboarding ja foram concluídos. Você pode revisar a agenda ou reabrir o tutorial quando quiser."}</p>
            <div style="margin-top:8px;">${checklist}</div>
          </div>
        `,
        icon: "info",
        background: colors.lightGray,
        color: colors.darkGray,
        confirmButtonColor: colors.red,
        confirmButtonText: currentStep?.cta || "Abrir agenda",
        showCancelButton: true,
        cancelButtonText: "Fazer depois",
      });

    if (result.isConfirmed && currentStep) {
      const guidedStorageKey = getGuidedStorageKeyByStep(currentStep.step);
      if (guidedStorageKey) {
        window.localStorage.removeItem(guidedStorageKey);
      }
      localStorage.savelocalStorage(String(currentStep.step));
      navigate(currentStep.route);
      return;
    }
  };

  const refreshNextTutorialStep = async () => {
    const tutorialInfo = await getNextTutorialStep();
    if (!tutorialInfo?.realStep) {
      setNextTutorialStep(null);
      return;
    }

    const pendingStep = tutorialSteps.find((item) => item.step === tutorialInfo.realStep) || null;
    setNextTutorialStep(pendingStep);
  };

  const goToNextTutorialStep = () => {
    if (!nextTutorialStep) return;
    window.sessionStorage.setItem(TUTORIAL_SESSION_PROMPT_KEY, String(nextTutorialStep.step));
    const guidedStorageKey = getGuidedStorageKeyByStep(nextTutorialStep.step);
    if (guidedStorageKey) {
      window.localStorage.removeItem(guidedStorageKey);
    }
    localStorage.savelocalStorage(String(nextTutorialStep.step));
    navigate(nextTutorialStep.route);
  };

  const reactivateFullTutorial = async () => {
    const result = await Swal.fire({
      title: "Reativar tutorial guiado?",
      text: "Se confirmar, o sistema vai habilitar novamente o tutorial completo desde o passo 1.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "rgb(93, 173, 226)",
      confirmButtonText: "Sim, reativar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    GUIDED_TUTORIAL_STORAGE_KEYS.forEach((key) => window.localStorage.removeItem(key));
    window.localStorage.removeItem("management_tutorial_agenda_seen");
    window.localStorage.setItem(TUTORIAL_REPLAY_KEY, "1");
    window.localStorage.removeItem(TUTORIAL_COMPLETED_KEY);
    window.sessionStorage.removeItem(TUTORIAL_SESSION_PROMPT_KEY);
    window.sessionStorage.removeItem(TUTORIAL_SESSION_STEP_OVERRIDE_KEY);
    localStorage.savelocalStorage("1");

    await openTutorial(true);
  };




  function escolherCidade(formData:any) {
    const opcoes = [
      { code: "BR", label: "BR — Brasil" },
      { code: "US", label: "US — United States" },
      { code: "PT", label: "PT — Portugal" },
    ];

    return (
      <select
        name="city"
        value={formData.city}
        onChange={(e) => setFormData({ ...formData, city: e.target.value })}
        style={{ 
          ...inputStyle, 
          cursor: "pointer", 
          appearance: "none", 
          backgroundColor: "white" 
        }}
      >
        <option value="" disabled>Escolher pais</option>
        {opcoes.map((o) => (
          <option key={o.code} value={o.label}>
            {o.label}
          </option>
        ))}
      </select>
    );
  }

  // ---------- Paleta de cores ----------
  const colors = {
    darkGray: "#7A7A7A",        
    
  };
  // ---------- Estilos Globais ----------
  const inputWrapperStyle = {
    display: "flex",
    alignItems: "center",
    border: `1px solid ${colors.darkGray}`,
    borderRadius: "10px",
    padding: "8px 12px",
    background: "#fff",
    gap: "10px",
  };
  const inputStyle = { border: "none", outline: "none", flex: 1, fontSize: "16px", color: colors.darkGray };


  useEffect(() => {
    handleGetDataUser();
    handleGetCountries();
    openTutorial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    refreshNextTutorialStep();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const handleOnboardingUpdated = () => {
      refreshNextTutorialStep();
    };

    const handleTutorialProgressed = () => {
      refreshNextTutorialStep();
    };

    window.addEventListener("management:onboarding-updated", handleOnboardingUpdated);
    window.addEventListener("management:tutorial-progressed", handleTutorialProgressed);
    return () => {
      window.removeEventListener("management:onboarding-updated", handleOnboardingUpdated);
      window.removeEventListener("management:tutorial-progressed", handleTutorialProgressed);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.pathname === "/AgendaPage") {
      window.localStorage.setItem("management_tutorial_agenda_seen", "1");
    }
  }, [location.pathname]);

  /**
   * Palette used:
   * Branco: #FFFFFF
   * Cinza claro: #F5F6FA (fallback #EDEDED)
   * Cinza escuro (text-muted): #7A7A7A
   * Preto suave (text): #222222
   * Azul claro (icons/links): rgb(93, 173, 226)
   * Vermelho rosado (buttons/indicators): rgb(255, 125, 112) (hover #FF5A5F)
   * Rosa magenta (highlights): rgb(93, 173, 226) (accent #C94DDB)
   */

  const dueDateNumber = Number(formData.due_date);
  const isPlanCanceled = !isNaN(dueDateNumber) && dueDateNumber < 0;
  const pageMetaByPath: Record<string, { title: string; subtitle: string }> = {
    "/HomePage": { title: "Painel Geral", subtitle: "Visão rápida das operações e status da conta." },
    "/UserPage": { title: "Signatários", subtitle: "Gerencie usuários e permissões de assinatura." },
    "/UploadPage": { title: "Upload de Contrato", subtitle: "Envie e organize contratos para processamento." },
    "/SeeContractPage": { title: "Contratos", subtitle: "Acompanhe contratos e ações disponíveis." },
    "/RegionForm": { title: "Regiões", subtitle: "Estruture as regiões do seu negócio." },
    "/UnitForm": { title: "Unidades", subtitle: "Cadastre e mantenha as unidades atualizadas." },
    "/CompanyPage": { title: "Empresas", subtitle: "Organize empresas por região e unidade." },
    "/NotificationPage": { title: "Notificações", subtitle: "Controle envios e alertas do sistema." },
    "/ReportPage": { title: "Relatórios", subtitle: "Consulte indicadores e histórico operacional." },
    "/AgendaPage": { title: "Agenda", subtitle: "Visualização mensal dos vencimentos e eventos contratuais." },
  };
  const currentPage = pageMetaByPath[location.pathname] || {
    title: "Gestão de Contratos",
    subtitle: "Experiência moderna para operação contratual.",
  };
  const isRouteActive = (routes: string[]) => routes.includes(location.pathname);
  const contractRoutes = ["/UploadPage", "/SeeContractPage"];
  const cadastroRoutes = ["/UserPage", "/RegionForm", "/UnitForm", "/CompanyPage", "/LocalForm"];
  const contractActive = isRouteActive(contractRoutes);
  const cadastroActive = isRouteActive(cadastroRoutes);

  useEffect(() => {
    if (contractActive) setContractOpen(true);
    if (cadastroActive) setCadastroOpen(true);
  }, [contractActive, cadastroActive]);

  useEffect(() => {
    const handleResize = () => {
      const mobileView = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(mobileView);
      setIsCollapsed(mobileView);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setIsCollapsed(true);
    }
  }, [location.pathname, isMobile]);

  return (
    <div className="layout-wrapper layout-content-navbar centerLayout modern-shell" style={{ background: "#FFFFFF", color: "#222222" }}>
      <div className="layout-container">
        {isMobile && !isCollapsed && (
          <button
            type="button"
            className="modern-sidebar-backdrop"
            onClick={closeMobileMenu}
            aria-label="Fechar menu"
          />
        )}

        {/* Sidebar */}
        {!isCollapsed && (
          <aside
              className={`layout-menu menu-vertical d-flex flex-column modern-sidebar ${isMobile ? "modern-sidebar-mobile" : ""}`}
              style={{
                minHeight: "100vh",
                width: isCollapsed ? "70px" : "270px",
                transition: "width 0.3s",
                paddingTop: "1rem",
              }}
            >
          {/* Brand / Logo */}
          <div
            className="app-brand d-flex align-items-center justify-content-between px-3 mb-4"
            style={{ paddingBottom: "1rem" }}
          >
            {!isCollapsed && (
              <>
                <div className="d-flex align-items-center">
                 <img
                    src={
                      formData.imagecompany_logo
                        ? `https://alexios.com.br:9598/uploads/logo/${formData.imagecompany_logo}`
                        : sem_image
                    }
                    onError={(e) => {
                      e.currentTarget.src = sem_image;
                    }}
                    className="rounded-circle modern-sidebar-avatar"
                    width={45}
                    height={45}
                    alt="Perfil"
                  />

                  <span className="ms-2 fw-bold" style={{ color: "#222222", fontSize: "1.1rem" }}>
                    Acesso Adm
                  </span>
                </div>

                {isMobile && (
                  <button
                    type="button"
                    className="btn modern-sidebar-close"
                    onClick={closeMobileMenu}
                    aria-label="Fechar menu"
                  >
                    <BiX size={24} />
                  </button>
                )}
              </>
            )}
          </div>

          {/* Menu Items */}
          <ul className="menu-inner list-unstyled px-2 modern-sidebar-nav">
             <li className="modern-nav-group-label">Principal</li>


             <li className="menu-item mb-1">
                <Link
                  to="/HomePage"
                  className={`menu-link modern-nav-link ${isRouteActive(["/HomePage"]) ? "is-active" : ""}`}
                  title="Página inicial do sistema"
                  onClick={closeMobileMenu}
                >
                  <span className="modern-nav-icon">
                   <BsBoxArrowRight color="rgb(93, 173, 226)" />
                  </span>
                  {!isCollapsed && <span className="modern-nav-text">Inicio</span>}
                </Link>
              </li>

            {/** Contrato */}
            <li className="menu-item mb-1">
              <div
                onClick={() => setContractOpen(!isContractOpen)}
                className={`menu-link modern-nav-trigger ${contractActive ? "is-active" : ""}`}
                style={{ cursor: "pointer" }}
                title="Gerenciar contratos"
              >
                <span className="modern-nav-icon">
                  <BsUpload color="rgb(93, 173, 226)" />
                </span>
                {!isCollapsed && <span className="modern-nav-text">Contratos</span>}
              </div>
              {isContractOpen && !isCollapsed && (
                <ul className="submenu list-unstyled mt-1 modern-submenu">
                  <li>
                    <Link
                      to="/UploadPage"
                      className={`modern-sub-link ${isRouteActive(["/UploadPage"]) ? "is-active" : ""}`}
                      onClick={closeMobileMenu}
                    >
                      Upload contrato
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/SeeContractPage"
                      className={`modern-sub-link ${isRouteActive(["/SeeContractPage"]) ? "is-active" : ""}`}
                      onClick={closeMobileMenu}
                    >
                      Ver contratos
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/** Cadastro */}
            <li className="modern-nav-group-label">Gestão</li>
            <li className="menu-item mb-1">
              <div
                onClick={() => setCadastroOpen(!isCadastroOpen)}
                className={`menu-link modern-nav-trigger ${cadastroActive ? "is-active" : ""}`}
                style={{ cursor: "pointer" }}
                title="Cadastro de regiões, unidades e locais"
              >
                <span className="modern-nav-icon">
                  <BsPerson color="rgb(93, 173, 226)" />
                </span>
                {!isCollapsed && <span className="modern-nav-text">Cadastro</span>}
              </div>
              {isCadastroOpen && !isCollapsed && (
                <ul className="submenu list-unstyled mt-1 modern-submenu">
                  <li>
                    <Link
                      to="/UserPage"
                      className={`modern-sub-link ${isRouteActive(["/UserPage"]) ? "is-active" : ""}`}
                      onClick={closeMobileMenu}
                    >
                      Signatários
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/RegionForm"
                      className={`modern-sub-link ${isRouteActive(["/RegionForm"]) ? "is-active" : ""}`}
                      onClick={closeMobileMenu}
                    >
                      Região
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/UnitForm"
                      className={`modern-sub-link ${isRouteActive(["/UnitForm"]) ? "is-active" : ""}`}
                      onClick={closeMobileMenu}
                    >
                      Unidade
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/CompanyPage"
                      className={`modern-sub-link ${isRouteActive(["/CompanyPage"]) ? "is-active" : ""}`}
                      onClick={closeMobileMenu}
                    >
                      Empresa
                    </Link>
                  </li>

                  
                  {/*
                    <li>
                    <Link
                      to="/LocalForm"
                      className="menu-link d-block p-2 rounded"
                      style={{ fontSize: "0.9rem", background: "transparent", transition: "all 0.3s", color: "#222222" }}
                    >
                      C.Local
                    </Link>
                  </li>
                  */}
                </ul>
              )}
            </li>

          
            {[
              { to: "/NotificationPage", icon: <BsBell color="rgb(93, 173, 226)" />, label: "Notificação", title: "Notificações do sistema" },
              { to: "/ReportPage", icon: <BsBarChart color="rgb(93, 173, 226)" />, label: "Relatórios", title: "Relatórios do sistema" },
              { to: "/AgendaPage", icon: <BsClockHistory color="rgb(93, 173, 226)" />, label: "Agenda", title: "Agenda do sistema" },
              /*{ to: "/PlanSubmasterPage", icon: <BsBoxArrowRight color="rgb(93, 173, 226)" />, label: "Plano", title: "Plano3" },
              { 
                to: "/HistoryPage", 
                icon: <BsClockHistory color="rgb(93, 173, 226)" />, 
                label: "Pagamento", 
                title: "Pagamento" 
              },*/

            ].map((item, idx) => (
              <li className="menu-item mb-1" key={idx}>
                <Link
                  to={item.to}
                  className={`menu-link modern-nav-link ${isRouteActive([item.to]) ? "is-active" : ""}`}
                  title={item.title}
                  onClick={closeMobileMenu}
                >
                  <span className="modern-nav-icon">
                    {item.icon}
                  </span>
                  {!isCollapsed && <span className="modern-nav-text">{item.label}</span>}
                </Link>
              </li>
            ))}


          
         
          </ul>

          </aside>
        )}

        {/* Page Wrapper */}
        <div className="layout-page" style={{ background: "#FFFFFF" }}>
          {/* Navbar */}
         <nav
  className="ml-2 mr-2 mt-2 navbar navbar-expand-lg rounded-4 px-4 py-2 modern-navbar"
  style={{
    background: "#FFFFFF", // navbar branco primário
    color: "#222222",
    border: "1px solid #EDEDED"
  }}
>
  <div className="d-flex align-items-center flex-grow-1">
    <button
      className="btn me-3 rounded-circle p-2"
      onClick={toggleMenu}
      style={{background:"rgb(93, 173, 226)", color:"white"}}
      aria-label={isCollapsed ? "Abrir menu" : "Ocultar menu"}
    >
      <BiMenu size={24} color="#FFFFFF" />
    </button>
  </div>

  <ul className="navbar-nav ms-auto d-flex align-items-center modern-navbar-actions">
    {nextTutorialStep && (
      <li className="nav-item me-2 d-flex align-items-center modern-navbar-action-item">
        <button
          type="button"
          className="btn btn-sm rounded-pill d-flex align-items-center gap-2 px-3 tutorial-next-step-btn modern-navbar-chip"
          onClick={goToNextTutorialStep}
          style={{
            background: "linear-gradient(135deg, rgba(93, 173, 226, 0.14), rgba(93, 173, 226, 0.06))",
            color: "#2B6EA6",
            border: "1px solid rgba(93, 173, 226, 0.22)",
            boxShadow: "0 10px 24px rgba(93, 173, 226, 0.10)",
            fontWeight: 600,
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: 999,
              background: "rgb(93, 173, 226)",
              display: "inline-block",
              boxShadow: "0 0 0 4px rgba(93, 173, 226, 0.12)",
            }}
          />
          <span className="d-none d-xl-inline" style={{ fontSize: 12, opacity: 0.75 }}>
            Proximo passo
          </span>
          <span style={{ fontSize: 13 }}>{nextTutorialStep.title}</span>
        </button>
      </li>
    )}
    <li className="nav-item me-2 d-flex align-items-center modern-navbar-action-item">
      <button
        type="button"
        className="btn btn-sm btn-outline-primary rounded-pill tutorial-replay-btn modern-navbar-chip"
        onClick={reactivateFullTutorial}
        style={{ borderColor: "rgb(93, 173, 226)", color: "rgb(93, 173, 226)" }}
      >
        Ver tutorial
      </button>
    </li>
    <li className="nav-item me-2 d-flex align-items-center modern-navbar-action-item">
      <ThemeToggle />
    </li>
    <li className="nav-item dropdown">
      <a
        className="nav-link dropdown-toggle d-flex align-items-center"
        data-bs-toggle="dropdown"
        href="#"
        style={{ color: "#222222" }}
      >
        <img
  src={
    formData.imagecompany_logo
      ? `https://alexios.com.br:9598/uploads/logo/${formData.imagecompany_logo}`
      : sem_image
  }
  onError={(e) => {
    e.currentTarget.src = sem_image;
  }}
  className="rounded-circle"
  width={45}
  height={45}
  alt="Perfil"
/>

      </a>
      <ul
        className="dropdown-menu dropdown-menu-end shadow rounded-3"
        style={{ background: "#FFFFFF", color: "#222222", border: "1px solid #EDEDED" }}
      >
        <li>
          <span className="dropdown-item-text fw-bold" style={{ color: "#222222" }}>
            {formData.name}
          </span>
        </li>
        <li>
          <button
            className="dropdown-item"
            onClick={() => setShowModalUpdateSubmaster(true)}
            style={{ color: "#222222", transition: "background 0.15s" }}
            onMouseEnter={e => (e.currentTarget.style.background = "rgba(74,144,226,0.06)")}
            onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
          >
            Editar Perfil
          </button>
        </li>
        <li>
          <button
            className="dropdown-item"
            onClick={logout}
            style={{ color: "#222222", transition: "background 0.15s" }}
            onMouseEnter={e => (e.currentTarget.style.background = "rgba(74,144,226,0.06)")}
            onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
          >
            Sair
          </button>
        </li>
      </ul>
    </li>
  </ul>
          </nav>

          <style jsx>{`
            .navbar {
              transition: all 0.3s ease;
            }

            .navbar .form-control:focus {
              box-shadow: 0 0 10px rgba(74,144,226,0.18);
              border-color: rgb(93, 173, 226);
            }

            .dropdown-menu {
              min-width: 200px;
            }

            .dropdown-item:hover {
              background-color: rgba(74,144,226,0.08);
              color: #222222;
            }
            .text-muted { color: #7A7A7A !important; }
          `}</style>

          {/* Content */}
          <div
            className={`content ml-2 mr-2 mt-3 modern-content ${isAgendaRoute ? "agenda-full-content" : ""}`}
            style={{ background: "#FFFFFF" }}
          >
            {!isAgendaRoute && (
            <div className="modern-card p-4 mb-4" style={{ background: "linear-gradient(140deg, rgba(231,76,60,0.08), rgba(255,255,255,0.96))" }}>
              <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
                <div>
                  <h3 className="mb-1" style={{ color: "#1f2937" }}>{currentPage.title}</h3>
                  <p className="mb-0" style={{ color: "#6b7280" }}>{currentPage.subtitle}</p>
                </div>
                <div className="d-flex flex-wrap gap-2">
                  <Link className="btn btn-sm modern-primary-btn" to="/UploadPage">Novo Contrato</Link>
                  <Link className="btn btn-sm btn-outline-danger" to="/UserPage">Signatários</Link>
                </div>
              </div>
            </div>
            )}
           
          {!isAgendaRoute && (
          <div
            className="d-flex align-items-center rounded-3 shadow-sm p-3 mb-4"
            style={{
              backgroundColor: "#FFFFFF", // fundo branco para destacar
              border: "1px solid #EDEDED",
            }}
          >

              {/* NOVO: alerta para plano cancelado por pagamento devedor */}
              
            {/* Ícone em círculo colorido */}
            <div
              className="d-flex align-items-center justify-content-center rounded-circle me-3"
              style={{
                backgroundColor: "rgb(93, 173, 226)",
                width: "48px",
                height: "48px",
              }}
            >
              <FiAward size={24} color="#FFFFFF" />
            </div>

            {/* Texto */}
            <div>
                {isPlanCanceled ? (
                  <div className="alert alert-danger d-flex align-items-center" role="alert">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    <div>
                      <strong>Plano cancelado:</strong>
                       existe um pagamento em atraso. O plano foi cancelado devido
                      a um débito pendente. Por favor, regularize o pagamento para reativar o plano.
                    </div>
                  </div>
                ) : <div className="plan-meta-label">Plano atual</div>}
              <div>
                <span className="fw-bold" style={{ color: "rgb(93, 173, 226)" }}>
                  <span>{formData?.features[0]?.plan}</span>
                </span>
                <span className="plan-meta-separator"> · </span>
                <span className="fw-bold plan-meta-days">{formData.due_date} /  dias</span>
              </div>
            </div>
          </div>
          )}
            <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.32, ease: 'easeOut' }}>{children}</motion.div>
          </div>

          {/* Footer */}
          <footer className="bg-light py-3 text-center modern-footer" style={{ background: "#F5F6FA", color: "#7A7A7A" }}>© 2025</footer>
        </div>
      </div>

        {/* Modal Editar Perfil */}
        {showModalUpdateSubmaster && (
          <div className="modal fade show d-block" tabIndex={-1}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0 rounded-4 shadow-lg">
            {/* Cabeçalho */}
            <div
              className="modal-header rounded-top-4 d-flex align-items-center justify-content-between"
              style={{ background: "rgb(255, 125, 112)", color: "#FFFFFF" }}
            >
              <h5 className="modal-title d-flex align-items-center fw-bold" style={{color:"#FFFFFF"}}>
                <i className="bi bi-person-lines-fill me-2 animate__animated animate__fadeInLeft"></i>
                Editar Perfil
              </h5>
              <button
                type="button"
                className="btn-md btn-close"
                onClick={() => setShowModalUpdateSubmaster(false)}
                aria-label="Fechar"
              />
            </div>
          <div
            className="d-flex mt-2 ml-2 mr-2 align-items-center rounded-3 shadow-sm p-3 mb-4"
            style={{
              backgroundColor: "#FFFFFF", // fundo branco para destacar
              border: "1px solid #EDEDED",
            }}
          >
            {/* Ícone em círculo colorido */}
            <div
              className="d-flex align-items-center justify-content-center rounded-circle me-3"
              style={{
                backgroundColor: "rgb(93, 173, 226)",
                width: "48px",
                height: "48px",
              }}
            >
              <FiAward size={24} color="#FFFFFF" />
            </div>

            {/* Texto */}
              <div>

                {isPlanCanceled ? (
                  <div className="alert alert-danger d-flex align-items-center" role="alert">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    <div>
                      <strong>Plano cancelado:</strong>
                       existe um pagamento em atraso. O plano foi cancelado devido
                      a um débito pendente. Por favor, regularize o pagamento para reativar o plano.
                    </div>
                  </div>
                ) :               
                <div className="plan-meta-label">Plano atual</div>}
                

              <div>
                <span className="fw-bold" style={{ color: "rgb(93, 173, 226)" }}>
                  <span>{formData?.features[0]?.plan}</span>
                </span>
                <span className="plan-meta-separator"> · </span>
                <span className="fw-bold plan-meta-days">{formData.due_date} /  dias</span>
              </div>
            </div>
          </div>
  

      {/* Corpo */}
      <div className="modal-body p-4" style={{ background: "#FFFFFF" }}>
        <div className="d-flex flex-column flex-md-row align-items-center gap-4">

          {/* Avatar */}
         <div className="text-center flex-shrink-0">
  <div className="position-relative d-inline-block avatar-hover">

    <img
      id="preview-image"
      src={
        formData.imagecompany_logo
          ? `https://alexios.com.br:9598/uploads/logo/${formData.imagecompany_logo}`
          : sem_image
      }
      onError={(e) => {
        e.currentTarget.src = sem_image;
      }}
      className="rounded-circle border"
      width={80}
      height={80}
      alt="Perfil"
      style={{ objectFit: "cover" }}
    />

    {/* Overlay explicativo quando não tem imagem */}
    {!formData.imagecompany_logo && (
      <div
        className="position-absolute top-0 start-0 w-100 h-100 rounded-circle d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: "rgba(0,0,0,0.45)",
          color: "#fff",
          fontSize: "0.75rem",
          fontWeight: 500,
          pointerEvents: "none",
        }}
      >
        Selecione uma imagem
      </div>
    )}

    <label
      htmlFor="imagecompany_logo"
      className="position-absolute bottom-0 end-0 rounded-circle p-2 shadow"
      style={{
        cursor: "pointer",
        border: "2px solid #FFFFFF",
        backgroundColor: "rgb(255, 125, 112)",
        color: "#FFFFFF",
      }}
      title="Selecionar imagem"
    >
      <i className="bi bi-camera-fill animate__animated animate__pulse"></i>
    </label>

    <input
      type="file"
      id="imagecompany_logo"
      accept="image/*"
      className="d-none"
      onChange={(e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // preview imediato
        const previewUrl = URL.createObjectURL(file);
        const img = document.getElementById("preview-image") as HTMLImageElement;
        if (img) img.src = previewUrl;

        // mantém seu fluxo atual
        handleFileChange(e);
      }}
    />
      </div>

      <small className="d-block mt-2 text-muted">
        Clique no ícone para <strong>selecionar uma imagem</strong>
      </small>
    </div>


          {/* Formulário */}

          <form className="flex-grow-1 row g-3" onSubmit={handleSubmitUpdate}>
              <div className="col-md-6">
                <label className="form-label fw-semibold d-flex align-items-center">
                  <i className="bi bi-person me-2 animate__animated animate__fadeInLeft" style={{ color: "rgb(93, 173, 226)" }}></i> Nome
                </label>
                <input
                  type="text"
                  className="form-control shadow-sm"
                  name="name"
                  placeholder="Nome"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{ borderColor: "#EDEDED" }}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold d-flex align-items-center">
                  <i className="bi bi-envelope-at me-2 animate__animated animate__fadeInLeft" style={{ color: "rgb(93, 173, 226)" }}></i> Email
                </label>
                <input
                  type="email"
                  className="form-control shadow-sm"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  style={{ borderColor: "#EDEDED" }}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold d-flex align-items-center">
                  <i className="bi bi-geo-alt me-2 animate__animated animate__fadeInLeft" style={{ color: "rgb(93, 173, 226)" }}></i> País
                </label>
                <div style={inputWrapperStyle}>
                  <span style={{ color: colors.red }}>🏙️</span>
                  {escolherCidade(formData)}
                </div>
              </div>
              <div className="col-md-12">
                <label className="form-label fw-semibold d-flex align-items-center">
                  <i className="bi bi-telephone me-2 animate__animated animate__fadeInLeft" style={{ color: "rgb(93, 173, 226)" }}></i> Telefone
                </label>
                <PhoneInput
                  country={"br"}
                  enableSearch
                  value={formData.number_phone}
                  onChange={(value) =>
                    setFormData({ ...formData, number_phone: value })
                  }
                  inputProps={{
                    name: "number_phone",
                    required: true,
                    className: "form-control shadow-sm",
                    placeholder: "Número de telefone",
                  }}
                
                />
              </div>
          </form>

        </div>
      </div>

      {/* Rodapé */}
      <div className="modal-footer rounded-bottom-4 d-flex justify-content-end" style={{ background: "#FFFFFF", borderTop: "1px solid #EDEDED" }}>
        <button
          className="btn d-flex align-items-center me-2 btn-secondary"
          onClick={() => setShowModalUpdateSubmaster(false)}
         
        >
          <i className="bi bi-x-circle me-2 animate__animated animate__fadeIn"></i> Fechar
        </button>
        <button
          className="btn d-flex align-items-center"
          onClick={handleSubmitUpdate}
                    style={{background:"rgb(93, 173, 226)", color:"white"}}

        >
          <i className="bi bi-save me-2 animate__animated animate__pulse"></i> Salvar Alterações
        </button>
        </div>
      </div>
    </div>
          </div>

        )}


      {/* ASSISTENTE IA GLOBAL */}
      <AIAssistant />

    </div>
  );
};

export default Layout;
